module.exports = __webpack_public_path__ + "img/bg_hb2@2x.d90166d0.png";